import { onMounted, onUnmounted } from "@vue/composition-api";
import emitter from "@/lib/emitter";
import { EVENTS } from "@/const";

export default function useHideMainMenu() {
  onMounted(() => emitter.emit(EVENTS.MAIN_MENU_HIDE, true));
  onUnmounted(() => emitter.emit(EVENTS.MAIN_MENU_HIDE, false));
}
